import { useMemo, useState } from "react";

import { ComboBoxPlain } from "~/components/formElements/ComboBox.tsx";
import { useAllCompanies } from "~/modules/client/api/company/companyQueries.ts";
import { byObjectProperty } from "~/utils/sortFunctions.ts";

type Props = {
	className?: string
	filterValues: string[];
	onChange: (newStatusFilter: string[]) => void;
};

const InvoiceStatusFilter = ({ onChange, filterValues }: Props) => {
	const [value, setValue] = useState<string|null>("");
	const {
		data: allClientsData,
	} = useAllCompanies();

	const optionsData = useMemo(() => {
		if (allClientsData) {
			return allClientsData.sort(byObjectProperty("displayName")).map(status => ({
				value: status.id,
				label: status.displayName,
				selected: filterValues.includes(status.id),
			}));
		}
		return [];
	}, [allClientsData, filterValues]);

	const handleStatusFilterChange = (statusId: string) => {
		if (filterValues.includes(statusId)) {
			onChange(filterValues.filter(id => id !== statusId));
		} else {
			onChange([...filterValues, statusId]);
		}
	};
	return <ComboBoxPlain optionsData={optionsData}
						  placeholder="Kunden auswählen..."
						  inputSize="sm"
						  value={value}
						  onChange={(value) => value ? setValue(value as string) : undefined}
						  onSelect={(value) => value ? handleStatusFilterChange(value as string) : undefined}
						  allowNew={false}
	resetOnSelect={true}
	/>;

};

export default InvoiceStatusFilter;